import { configureStore } from "@reduxjs/toolkit";
import index from "./news";
export const store = configureStore({
  reducer: {
    index,
  },
});

export default store;
